export const embedMode = {
  lightbox: "LIGHT_BOX",
  inLine: "IN_LINE",
  fullWindow: "FULL_WINDOW",
  sizedContainer: "SIZED_CONTAINER",
};

export const viewMode = {
  fitPage: "FIT_PAGE",
  fitWidth: "FIT_WIDTH",
};

export const exitType = {
  close: "CLOSE",
  return: "RETURN",
};
